//设计资源相关的请求
import { request } from "@/utils";

//通过项目Id获取项目设计资源
export function getDesignListByProjectIdAPI(projectId) {
  return request({
    url: '/project-design/get-project-design-list-by-project-id',
    method: 'GET',
    data: projectId
  })
}

//添加项目设计资源
export function addDesignAPI(data) {
  return request({
    url: '/project-design/add-project-design',
    method: 'POST',
    data: data
  })
}

//获取项目设计列表
export function getDesignResListAPI() {
  return request({
    url: '/project-design/get-design-res-list',
    method: 'GET'
  })
}

//获取项目设计详情
export function getDesignResAPI(id) {
  return request({
    url: `/project-design/get-design-res?designId=${id}`,
    method: 'POST'
  })
}